import {Utils} from "../utils/specific.mjs"

/**
constructor:
* getQueriableValues 
* setQueriableProperties
> { ka :va, kb: vb, kc: vc} 
> queriableFileds ka, kc 
> queriableValues va, vc 
> { ka: va, kb: vb, kc: vc} -> [va,vc] -> testQuery
 */

export class StopFilter{
    constructor(){
        var _queriableProperties = [];

        Object.defineProperty(this,'queriableProperties',{
            set : function(props){ _queriableProperties = props; },
            get : function(){ return _queriableProperties }
        });

    }

    // ==========
    // private 
    // ----------
    getQueriableProperties(){ return this.queriableProperties; }

    getQueriableValues(data){
        return this.getQueriableProperties().map(prop => data[prop])
    }

    getQuery(){ return this.query }

    getNormalizedRegexQuery(){
        var query = this.getQuery();
        var normQuery = Utils.normalizeString(query);
        var substrRegex = new RegExp(normQuery,'i');
        return substrRegex;
    }

    filterByQuery(data){ 
        var substrRegex = this.getNormalizedRegexQuery();
        var strings = this.getQueriableValues(data);
        var normStrings = strings.map(str => Utils.normalizeString(str));
        if (!normStrings.length) return true;
        normStrings = normStrings.filter(normStr => substrRegex.test(normStr));
        return normStrings.length;
    }


    // ==========
    // public 
    // ----------
    setQueriableProperties(array){
        this.queriableProperties = array;
    }

    setQuery(query){
        this.query = query;
    }

    filter(dataArray){ 
        return dataArray.filter(this.filterByQuery.bind(this)) 
    }
}